import request from './base'

export const getUserList = (params) => {
    return request.post("/merchant/v1/user/list", params, { delay:1000})
}

export const addUser = (params) => {
    return request.post("/merchant/v1/user/add", params)
}

export const modifyUser = (params) => {
    return request.post("/merchant/v1/user/modify", params)
}

export const deleteUser = (params) => {
    return request.post("/merchant/v1/user/delete", params)
}

export const userModifyPassword = (params) => {
    return request.post("/merchant/v1/user/password", params)
}

export const resetPassword = (params) => {
    return request.post("/merchant/v1/user/password", params)
}


// WEBPACK FOOTER //
// ./src/api/user.js